//import statusOrderbuy from "./statusOrderbuy.vue";
import statusOrderbuy from "@/views/modules/projects/statusOrderbuy.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import DateTimeBlinking from "@/components/functionals/DateTimeBlinking.vue";
import OrderBuyPro from "@/views/modules/projects/OrderBuyProStatusO";
import { formatterMoney } from "@/utils";
export const ColumnsOrderBuyTable = [
  {
    prop: "No",
    label: "N° ",
    width: 150,
    sortable: true
  },

  {
    prop: "BuyName",
    label: "Nombre de compra",
    width: 150,
    sortable: true
  },
  // {
  //   prop: "Description",
  //   label: "Descripcion",
  //   width: 150
  // },
  {
    prop: "Stat",
    label: "Estado",
    width: 150,
    sortable: true,
    formatter: statusOrderbuy
  },
  {
    prop: "InvoiceCost",
    label: "Monto",
    width: 150,
    sortable: true
  },
  {
    prop: "OStatus",
    label: "Estado Orden",
    width: 150,
    sortable: true,
    formatter: OrderBuyPro
  },
  {
    prop: "BuyNPro",
    label: "N° de compra proveedor",
    width: 150,
    sortable: true
  },
  {
    prop: "LCode",
    label: "Cód.almacén",
    width: 150,
    sortable: true
  },

  // {
  //   prop: "CCode",
  //   label: "Cód.divisa",
  //   width: 150,
  //   sortable: true
  // },

  {
    prop: "OrdenD",
    label: "Fecha de Emisión Doc.",
    width: 150,
    sortable: true,
    formatter: DatetimeFormatter
  },
  {
    prop: "PDate",
    label: "Fecha de Registro",
    width: 150,
    sortable: true,
    formatter: DatetimeFormatter
  },

  {
    prop: "DueD",
    label: "Fecha de vencimiento",
    width: 150,
    sortable: true,
    formatter: DateTimeBlinking
  },
  {
    prop: "RequestedRD",
    label: "Fecha de recep.solicitada",
    width: 150,
    sortable: true,
    formatter: DatetimeFormatter
  },
  {
    prop: "PDiscountD",
    label: "Fecha Pedido",
    width: 150,
    sortable: true,
    formatter: DatetimeFormatter
  }
];

export const columnsLinesOrderBuy = [
  {
    prop: "DocumentNo",
    label: "N° ",
    width: 120,
    sortable: true
  },
  {
    prop: "LineNo",
    label: "Linea #",
    width: 100,
    sortable: true
  },
  {
    prop: "NoBuy",
    label: "# Compra ",
    width: 130,
    sortable: true
  },
  {
    prop: "Description",
    label: "Descripcion",
    width: 200,
    sortable: true
  },
  {
    prop: "Quantity",
    label: "Cantidad",
    width: 120,
    sortable: true
  },
  {
    prop: "UnitCost",
    label: "Precio Unidad",
    width: 120,
    sortable: true,
    formatter: (row) => formatterMoney(row.UnitCost)
  },
  {
    prop: "Amount",
    label: "Monto",
    width: 120,
    sortable: true,
    formatter: (row) => formatterMoney(row.Amount)
  }
];
